import * as types from './types'

export const receiveError = (err) => ({
  type: types.RECEIVE_ERROR,
  payload: err
})

export const clearErrors = () => ({
  type: types.CLEAR_ERROR
})

export const fetchResource = (payload = false) => ({
  type: types.FETCH_RESOURCE,
  payload
})
